export default __webpack_public_path__ + "static/media/recommendationComingSoon.289275b6.svg";